import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { Checkbox } from "baseui/checkbox";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import request from "../../utils/http";

const JobCodeRateAdmin = () => {
	const urlParams = useParams() as any;
	const { jobCodeRateId } = urlParams;
	const isEditMode = !!jobCodeRateId;
	const navigate = useNavigate();

	const [rate, setRate] = useState(0);
	const [active, setActive] = useState(true);
	const [defaultRate, setDefaultRate] = useState(false);

	useEffect(() => {
		// Fetch the job code rate details based on the 'id' parameter when the component mounts
		if (jobCodeRateId) {
			// Fetch job code rate details for the given 'id' and populate the state variables.
			// Implement this part based on the API.
			const fetchJobCodeRate = async () => {
				try {
					const result = await request(
						"GET",
						`/api/admin/jobcoderate/${jobCodeRateId}`,
						null
					);
					if (result.success && result.data) {
						const { jobCodeRate, active, defaultRate } = result.data;
						setRate(jobCodeRate);
						setActive(active);
						setDefaultRate(defaultRate);
					} else {
						// Handle error when fetching job code details.
					}
				} catch (error) {
					// Handle error loadingg job codes.
				}
			};
			fetchJobCodeRate();
		}
	}, [jobCodeRateId]);

	const saveJobCodeRate = async () => {
		// Implement the logic to create or update a job code rate.
		// Can use the 'isEditMode' flag to determine whether to create or update.
		// Should also send 'rate' and 'active' values to the server API
		try {
			if (!rate) {
				toast.error("Rate value is required.");
				return;
			}

			const requestData = {
				JobCodeRate: rate,
				Active: active,
				DefaultRate: defaultRate,
			};

			let result;

			if (isEditMode) {
				// Update existing job code rate
				result = await request(
					"PUT",
					`/api/admin/jobcoderate/update/${jobCodeRateId}`,
					requestData
				);
			} else {
				// Create a new job code rate
				result = await request(
					"POST",
					`/api/admin/jobcoderate/create`,
					requestData
				);
			}

			if (result.success) {
				toast.success(
					isEditMode
						? "Job Code Rate updated successfully"
						: "Job Code Rate created successfully."
				);
				navigate(`/job-code-rates`);
			} else {
				toast.error(
					isEditMode
						? result.message ?  result.message : "Error updating job code rate"
						: result.message ?  result.message : "Error creating job code rate"
				);
			}
		} catch (error) {
			// Handle error saving job code rate.
		}
	};

	const handleCancel = () => {
		navigate(`/job-code-rates`);
	};

	return (
		<>
			<h1>{isEditMode ? "Edit Job Code Rate" : "Create Job Code Rate"}</h1>
			<div>
				<FormControl label={"Rate"}>
					<Input
						value={rate}
						onChange={(e) => setRate(parseFloat(e.currentTarget.value))}
						type="number"
					/>
				</FormControl>
				<FormControl label={"Default Rate"}>
					<Checkbox checked={defaultRate} onChange={() => setDefaultRate(!defaultRate)} />
				</FormControl>
				{isEditMode && (
					<FormControl label={"Active"}>
						<Checkbox checked={active} onChange={() => setActive(!active)} />
					</FormControl>
				)}
				<div>
					{isEditMode ? (
						<>
							<Button onClick={saveJobCodeRate}>Save</Button>
						</>
					) : (
						<Button onClick={saveJobCodeRate}>Create</Button>
					)}
					&nbsp;
					<Button onClick={handleCancel} kind="secondary">
						Cancel
					</Button>
				</div>
			</div>
		</>
	);
};

export default JobCodeRateAdmin;
